/**
 * Auth endpoint wrappers (the cookie-bearing surface).
 *
 * `refresh` is the linchpin: called at cold boot and by the factory's
 * silent-refresh interceptor. `logout` is fired by the sign-out action.
 */
import { api } from './client';
import type { AuthTokenResponse } from './types';

export const authApi = {
  async refresh(): Promise<AuthTokenResponse> {
    const { data } = await api.post<AuthTokenResponse>('/api/auth/refresh', {});
    return data;
  },

  /**
   * Backchannel exchange of the single-use `?code=` that centralized login
   * delivers when saas-auth's authorization-code delivery is on. Credentialed
   * (the HttpOnly binding cookie must travel) and PRE-SESSION: the route
   * establishes the session, so it is neither bearer- nor CSRF-gated — see
   * `isCsrfProtected` / `isBearerPath` in ./client. 400 CODE_INVALID on any
   * rejection.
   */
  async exchange(code: string): Promise<AuthTokenResponse> {
    const { data } = await api.post<AuthTokenResponse>('/api/auth/session/exchange', { code });
    return data;
  },

  async logout(): Promise<void> {
    await api.post('/api/auth/logout', {});
  },
};
